import { IPackagingParts, PackagingParts } from 'interfaces/IPackaging'
import BaseAutocomplete from './baseAutocomplete'

export const PACKAGING_PART_ID = 'Packaging Part ID'
export const PART_NAME = 'Part Name'

const headers = [
  {
    id: 'packagingPartId',
    numeric: false,
    disablePadding: true,
    label: 'Kode Komponen',
    width: 'medium',
  },
  {
    id: 'partName',
    numeric: false,
    disablePadding: false,
    label: 'Nama Komponen',
    width: 'medium',
  },
  {
    id: 'stock',
    numeric: false,
    disablePadding: false,
    label: 'Stok',
    width: 'small',
  },
]

export default function LoadPackagingPartAutocomplete(props: {
  name?: string
  onChange?: (packagingPart: IPackagingParts) => void
  onInputChange?: (packaging: string) => void
  disabled?: boolean
  required?: boolean
  showInactive?: boolean
  getMatchedData?: (packagingParts: IPackagingParts[]) => void
  showDetailedTable?: boolean
  loadAll?: boolean
}) {
  const { name, loadAll, onChange } = props

  let url = '/packaging/getPackagingPart'

  const handleChange = (part?: IPackagingParts | null) => {
    onChange?.(part ?? new PackagingParts({}))
  }

  const responseMapper = (packagingParts: IPackagingParts) => {
    return `${packagingParts.packagingPartId} - ${packagingParts.partName}`
  }

  return (
    <BaseAutocomplete
      {...props}
      url={url}
      headers={headers}
      label="Kode Part Kemasan"
      loadAll={loadAll}
      name={name}
      responseMapper={responseMapper}
      onChange={handleChange}
    />
  )
}
